import type { ArquivoBinarioDto, ArquivoBinarioEnvioDto } from '../types';

function base64ToBlob(base64: string, mimeType: string): Blob {
    const byteCharacters = atob(base64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: mimeType });
}

export const toFile = (input: Partial<ArquivoBinarioDto> | null | undefined): File | null => {
    if (!input?.binary || !input.name || !input.type) {
        return null;
    }
    const blob = base64ToBlob(input.binary, input.type);
    return new File([blob], input.name, { type: input.type });
};

export const downloadFile = (file: File): void => {
    const url = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = url;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export const mapFilesToDto = async (files: readonly File[]): Promise<ArquivoBinarioEnvioDto[]> => {
    const fileDtos = await Promise.all(files.map(file => {
        return new Promise<ArquivoBinarioEnvioDto>((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const arrayBuffer = reader.result;
                if (!(arrayBuffer instanceof ArrayBuffer)) {
                    reject(new Error('Não foi possível ler o arquivo selecionado.'));
                    return;
                }
                const byteArray = new Uint8Array(arrayBuffer);
                resolve({
                    name: file.name,
                    type: file.type,
                    binary: Array.from(byteArray)
                });
            };
            reader.onerror = (error) => reject(error);
            reader.readAsArrayBuffer(file);
        });
    }));
    return fileDtos;
};
